import type { ReactNode } from "react";
import Box from "@mui/material/Box";
import { OverflowMenu, type OverflowAction } from "./OverflowMenu";

interface PhoneHeaderActionsProps {
  /** The one action that stays a visible button, e.g. "Create Event". */
  primary?: ReactNode;
  /** Everything else (Import, Export, SharePoint) goes in the ⋮ menu. */
  more?: OverflowAction[];
}

/**
 * Phone version of a PageHeader action row: one primary button and a ⋮ menu.
 * Pages pass it as `action` when useIsPhone() is true and keep their desktop
 * button row unchanged otherwise.
 */
export function PhoneHeaderActions({ primary, more = [] }: PhoneHeaderActionsProps) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      {primary}
      <OverflowMenu actions={more} ariaLabel="More page actions" testId="page-actions-more" />
    </Box>
  );
}
